import { Controller } from "@hotwired/stimulus";
import Handlebars from "handlebars/dist/handlebars.min";
import { call } from "hb/insights/use";

Handlebars.registerHelper("isDefined", function (value, options) {
  if (value !== undefined && value !== null) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

export default class extends Controller {
  // Lookups
  //
  find(selector) {
    return this.element.querySelector(`:scope ${selector}`);
  }

  findAll(selector) {
    return this.element.querySelectorAll(`:scope ${selector}`);
  }

  // Templating
  //
  compileTemplate(html) {
    return Handlebars.compile(html);
  }

  compileElement(ele) {
    if (!ele) return;
    return this.compileTemplate(ele.innerHTML);
  }

  compileSelector(selector) {
    const ele = this.find(selector);
    if (!ele) return;
    return this.compileElement(ele);
  }

  // Default resize callback
  //
  resize(evt) {
    this.chartSize = evt;

    if (this.query) call(this, "render");
  }
}
